import { render } from "./Settings-page.vue?vue&type=template&id=1c315ccc&scoped=true"
import script from "./Settings-page.vue?vue&type=script&lang=js"
export * from "./Settings-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=1c315ccc&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c315ccc"]])

export default __exports__